// removed by extract-text-webpack-plugin
module.exports = {"navigationControlBtns":"map-module__navigationControlBtns___2rBWn","labelProject":"map-module__labelProject___1IeFC","labelOrganisation":"map-module__labelOrganisation___2o8yW","labelLocation":"map-module__labelLocation___17hcc","popUpPar":"map-module__popUpPar___3DRnr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map/map.module.scss
// module id = 964
// module chunks = 0